var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import TaskPriorityService from "../../../Domain/TaskPriority/TaskPriority.service";
const TaskPriorityBadge = (_a) => {
    var { priority, className } = _a, otherProps = __rest(_a, ["priority", "className"]);
    switch (priority.id) {
        case TaskPriorityService.High.id:
            return (_jsx("div", Object.assign({}, otherProps, { className: "badge badge-danger " + (className || ""), children: priority.label })));
        case TaskPriorityService.Medium.id:
            return (_jsx("div", Object.assign({}, otherProps, { className: "badge badge-secondary " + (className || ""), children: priority.label })));
        case TaskPriorityService.Low.id:
            return (_jsx("div", Object.assign({}, otherProps, { className: "badge badge-primary " + (className || ""), children: priority.label })));
        default:
            return null;
    }
};
export default TaskPriorityBadge;
